import list from "../assets/data/projectsCompleted.json";

export const getCompletedProject = (id: string) => {
  return list.find((project) => project.id === id);
};
